import { Component, OnInit } from '@angular/core';
import { LocalStorage } from 'ngx-webstorage';
import { LoginService } from '../data/login.service';
import { finalize, tap } from 'rxjs/operators';
import { tapOnError } from '../../core/public-api';
import { environment } from 'projects/desktop/src/environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
    selector: 'app-login-form',
    templateUrl: './login-form.component.html',
    styleUrls: ['./login-form.component.scss'],
    providers: [DeviceDetectorService]
})
export class LoginFormComponent implements OnInit {
    loading = false;

    @LocalStorage()
    userName: string;

    password: string;

    authError = '';

    loginLoading = false;

    systemState = environment.systemState;

    systemStates = [{
        title: 'Seattle'
    }, {
        title: 'California'
    }]

    constructor(
        private loginService: LoginService,
        private deviceDetector: DeviceDetectorService
    ) {
        if (this.deviceDetector.isMobile() || this.deviceDetector.isTablet()) {

        }
    }

    ngOnInit() {

    }

    onSubmit() {
        this.authError = '';

        this.loginLoading = true;

        this.loginService
            .doAuth(this.userName, this.password)
            .pipe(
                tapOnError(error => {
                    this.authError = 'Server error'
                }),
                finalize(() => {
                    this.loginLoading = false;
                })
            )
            .subscribe(ans => {
                if (!ans.success) {
                    this.authError = ans.reason
                }
            })
    }

    switchSystem(clickedSys: string) {
        this.loginService.switchSystem(clickedSys)
    }
}
